import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageChangerStyles } from './language-changer.styles';

const LanguageChanger = () => {
  const { i18n } = useTranslation('app');

  // Get user browser language preference
  const getBrowserLanguage = () => {
    // Check navigator.language and navigator.languages
    const browserLangs = [
      navigator.language,
      ...(navigator.languages || [])
    ].map(lang => lang.toLowerCase().split('-')[0]); // Extract just the language code (e.g., 'de' from 'de-CH')

    // Check if user has DE or FR preference
    if (browserLangs.includes('fr')) return 'fr';
    if (browserLangs.includes('de')) return 'de';

    // Default to DE if neither FR nor DE
    return 'de';
  };

  // Load language on component mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('userLanguage');

    if (savedLanguage) {
      // User has previously selected a language - stick to it
      if (savedLanguage !== i18n.language) {
        i18n.changeLanguage(savedLanguage);
      }
    } else {
      // No saved preference - use browser language detection
      const browserLanguage = getBrowserLanguage();
      localStorage.setItem('userLanguage', browserLanguage);
      localStorage.setItem('languageSource', 'browser'); // Track that this came from browser detection
      i18n.changeLanguage(browserLanguage);
    }
  }, [i18n]);

  const changeLanguage = (lng) => {
    // Save the language choice to localStorage
    localStorage.setItem('userLanguage', lng);
    localStorage.setItem('languageSource', 'user'); // Track that user manually selected this
    i18n.changeLanguage(lng);
  };

  return (
    <LanguageChangerStyles
      as="button" // or however your styled component handles button styling
      onClick={() => {
        const targetLanguage = i18n.language === 'de' ? 'fr' : 'de';
        changeLanguage(targetLanguage);
      }}
    >
      {i18n.language === 'de' ? 'Français' : 'Deutsch'}
    </LanguageChangerStyles>
  );
};

export default LanguageChanger;